import { Font, StyleSheet } from "@react-pdf/renderer";

import RobotoBold from "../../../../assets/fonts/Roboto/Roboto-Bold.ttf";
import RobotoBoldItalic from "../../../../assets/fonts/Roboto/Roboto-BlackItalic.ttf";
import RobotoItalic from "../../../../assets/fonts/Roboto/Roboto-Italic.ttf";
import RobotoMedium from "../../../../assets/fonts/Roboto-Medium.ttf";

// Register the custom font
Font.register({
  family: "CustomFontFamily",
  fonts: [
    { src: RobotoMedium, fontWeight: 400 }, // Normal weight
    { src: RobotoBold, fontWeight: 700 }, // Bold weight
    { src: RobotoItalic, fontWeight: 400, fontStyle: "italic" }, // Italic weight
    { src: RobotoBoldItalic, fontWeight: 700, fontStyle: "italic" }, // Italic weight
  ],
});

export const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#E4E4E4",
    padding: 10,
    fontFamily: "CustomFontFamily",
  },
  link: {
    color: "blue",
    textDecoration: "underline",
  },
  title: {
    fontSize: 16,
    textAlign: "center",
    marginTop: 5,
    fontFamily: "CustomFontFamily",
  },
  subtitle: {
    fontSize: 14,
    textAlign: "center",
    marginTop: 10,
    fontFamily: "CustomFontFamily",
  },
  lastSubtitle: {
    fontSize: 14,
    textAlign: "center",
    marginTop: 10,
    marginBottom: 30,
    fontFamily: "CustomFontFamily",
  },
  header: {
    position: "absolute",
    top: 10,
    left: 10,
    fontSize: 10,
    height: 60,
    fontFamily: "CustomFontFamily",
  },
  table: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginBottom: 20,
    fontFamily: "CustomFontFamily",
  },
  tableHidden: {
    width: "100%",
    marginBottom: 20,
    fontFamily: "CustomFontFamily",
    border: "none",
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
    fontFamily: "CustomFontFamily",
  },
  tableCol: {
    width: "33.3%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderRightStyle: "solid",
    padding: 5,
    fontSize: 12,
    fontFamily: "CustomFontFamily",
    flexWrap: "wrap",
  },
  tableColHorizontal: {
    width: "50%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderRightStyle: "solid",
    padding: 5,
    fontSize: 12,
    fontFamily: "CustomFontFamily",
  },
  tableCell: {
    fontSize: 10,
    fontFamily: "CustomFontFamily",
    wordBreak: "break-all",
  },
  topRightCorner: {
    position: "absolute",
    top: 10,
    right: 10,
    fontSize: 10,
    textAlign: "right",
    fontFamily: "CustomFontFamily",
  },
  signatureImage: {
    maxWidth: 220,
    height: 20,
    objectFit: "contain",
    alignSelf: "flex-start",
  },
  logoImage: {
    width: 84,
    maxHeight: 48,
    objectFit: "contain",
    alignSelf: "center",
    marginTop: 5,
  },
  // Smaller logo variant for Checklist PDFs (~35% of current size)
  logoImageSmall: {
    width: 84,
    maxHeight: 48,
    objectFit: "contain",
    alignSelf: "center",
    marginTop: 5,
  },
  logoContainer: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
  },
  centeredView: {
    alignItems: "center",
    width: "100%",
    marginTop: 20, // Adjust this value as needed
  },
});

export interface ITextFields {
  otpadKorektivnaMjera: string;
  evidencija: string;
  period: string;
  datum: string;
  imeIPrezime: string;
  potpis: string;
  naziv: string;
  tipEvidencije: string;
  slikaDeklaracije: string;
  stanjeKorekcije: string;
  opisKorekcije: string;
  stanjeKontrole: string;
  opisKontrole: string;
  vrsta: string;
  primjena: string;
  upustvoZaUpotrebu: string;
  opis: string;
  slika: string;
  address: string;
  phoneNumber: string;
  idTax: string;
  pdvTax: string;
  productType: string;
  posiljalac: string;
  potpisPosiljalac: string;
  primalac: string;
  potpisPrimalac: string;
  dokument: string;
  primjedba: string;
  korektivnaMjera: string;
  temperatura: string;
  datumObuke: string;
  mjestoObuke: string;
  tipObuke: string;
  izvrsilacObuke: string;
  tema: string;
  cilj: string;
  verifikacijaEfikasnosti: string;
  imePrezime: string;
  radnoMjesto: string;
  verifikacijaPrisustvaPotpis: string;
  verifikacijaEdukatoraPotpis: string;
  izvrsioc: string;
  potpisIzvrsioca: string;
  brojRacuna: string;
  uposlenik: string;
  vaziOd: string;
  vaziDo: string;
  tip: string;
  vrstaOtpada: string;
  otpadPredao: string;
  otpadPrimio: string;
  kolicina: string;
  primaoc: string;
  ocitanaTemperatura: string;
  dozvoljenaTempMin: string;
  dozvoljenaTempMax: string;
  dozvoljenoOdstupanje: string;
  stanje: string;
  opisMjeereKorekcije: string;
  ocitanaTemperaturaKorekcije: string;
  dozvoljenaTempMinKorekcije: string;
  dozvoljenaTempMaxKorekcije: string;
  imePrezimeKorekcije: string;
  potpisIzvrsiocaKorekcije: string;
  datumKorekcije: string;
  vrijemeKorekcije: string;
  zadovoljenaKontrola: string;
  donjaGranicaHeader: string;
  gornjaGranicaHeader: string;
  rasponHeader: string;
  odabraniPeriod: string;
  upisaoFooter: string;
  potpisFooter: string;
  napomena: string;
  tackaPrimjene: string;
  da: string;
  ne: string;
  proizvod: string;
  ispravnaPosiljka: string;
  kontrolisaoPrimioRadove: string;
  ispunjeno: string;
}
